import React from "react";
import { Provider } from "react-redux";
import { Link } from "react-router";
import documentUploaderImg from "../images/document_uploader.png";
import payrollEmaillerImg from "../images/payroll_emailler.png";
import upload8879Img from "../images/upload_8879.png";
import qr_img from "../images/qr_img.png";
import organizer_upload from "../images/organizer_upload.png";
import source_doc_upload from "../images/source_documents.png";
import ShowPackageList from "./documentUploader/ShowPackageList";
import QRCode from "./documentUploader/QRCode";
import admin_img from "../images/admin_img.png";
// import Admin from './Admin';

const Home = React.createClass({
  componentDidMount: function () {
    console.log("componentDid Mount called************");
    window.addEventListener("load", this.getTokens);
  },
  getTokens: function () {
    console.log("getTokens loaded Successful");

    const currentUrl = window.location.href;
    if (currentUrl.includes("code") && currentUrl.includes("session_state")) {
      console.log("=======*=====");
      const redirectUrl = `${process.env.BASE_URL}/Home`;
      console.log(window);
      const queryString = window.location.search;
      const parameters = new URLSearchParams(queryString);
      const decodedCchOAuthAccessCode = decodeURI(parameters.get("code"));

      console.log(decodedCchOAuthAccessCode);
      const baseAuth =
        "493b907f-f58e-7f5e-2c3d-abbecff1200b:53a15c39-ce0e-a9d6-28c2-bb2f5a7bfb9b";
      const baseAuth64 = btoa(baseAuth);
      const formData = new URLSearchParams({
        code: `${decodedCchOAuthAccessCode}`,
        redirect_uri: `${redirectUrl}`,
        grant_type: "authorization_code",
      });
      let accessTokens = "";
      fetch("https://login.cchaxcess.com/ps/auth/v1.0/core/connect/token", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: `Basic ${baseAuth64}`,
        },
        body: formData.toString(),
      })
        .then((response) => response.json())
        .then((data) => {
          this.accessTokens = data;
          console.log(this.accessTokens);
          // console.log(this.props.authData.email);
          if (this.accessTokens) {
            console.log("inside saving api");
            let item = {
              email: this.props.authData.email,
              access_token: this.accessTokens.access_token,
              expires_in: this.accessTokens.expires_in,
              refresh_token: this.accessTokens.refresh_token,
            };
            let url = "/api/cch/saveCCHToken";
            let options = {
              method: "POST",
              headers: {
                token: this.props.token.jwt,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(item),
            };

            fetch(url, options)
              .then((res) => {
                console.log(res);
                if (res.status == 200) return res.json();
              })
              .then((json) => {
                console.log("Log in validated successfully", json);
              });
          }
        });
    }
  },
  handleClick: function () {
    const popup = document.createElement("div");
    popup.className = "popup";
    popup.innerHTML = `
				   <div class="popup-content">
				    <h3>Temporarily unavailable</h3>
				    <br>
				    <button class="close-btn">Close</button>
				  </div>`;
    document.body.appendChild(popup);
    const closeBtn = popup.querySelector(".close-btn");
    closeBtn.addEventListener("click", () => {
      document.body.removeChild(popup);
    });
  },

  render() {
    return (
      <div>
        <div className="homescreen">
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              onClick={this.handleClick}
            >
              <img alt="" src={documentUploaderImg} />
              <span>Email Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/job/Payroll/PayrollInput"
            >
              {/*<a onClick={this.handleClick}>*/}
              <img alt="" src={payrollEmaillerImg} srcset="" />
              <span className="">Pay Stub Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/job/Payroll/upload8879s"
            >
              <img alt="" src={upload8879Img} srcset="" />
              <span className="">8879 Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/QRCode"
            >
              <img src={qr_img} srcSet="" />
              <span>Engagement Letter Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/OrganizerUpload"
            >
              <img alt="" src={organizer_upload} srcSet="" />
              <span className="">Organizer Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/SourceDocumentUpload"
            >
              <img alt="" src={source_doc_upload} srcSet="" />
              <span className="">Source Document Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/GenericPorter"
            >
              <img alt="" src={organizer_upload} srcSet="" />
              <span className="">Generic Porter</span>
            </a>
          </div>
          <div className="homeMenu">
            <a
              style={{ display: "flex", cursor: "pointer", height: "100%" }}
              href="/Administration"
            >
              <img alt="" src={admin_img} srcSet="" />
              <span className="">Admin</span>
            </a>
          </div>
        </div>
      </div>
    );
  },
});

export default Home;



// WEBPACK FOOTER //
// ./app/components/Home.js